export const LEARNING_OBJECTIVE_MINIMUM = 2;
export const LEARNING_OBJECTIVE_MAXIMUM = 4;
export const SKILLS_MINIMUM = 3;
export const LEARNING_PATH_DESCRIPTION_MAX_LENGTH = 500;
export const LEARNING_PATH_PRODUCTS_MINUMUM = 2;
export const DEFAULT_BADGE_LOGO_HEIGHT = 72;
